import { Text } from "@mantine/core"
import { useHover } from "@mantine/hooks"
import { useNavigate } from "react-router-dom"

import useCmdClick from "@costory/front/components/common/CmdClick"
import highlightCell from "@costory/front/components/common/HighlightCell"
import { navigateWithCmd } from "@costory/front/components/common/NavigateWithCmd"

type HoverHighlightCellProps = {
  value: string
  id: string
  basePath?: string
  disabled?: boolean
}

export const HoverHighlightCell = ({
  value,
  id,
  basePath = "",
  disabled = false,
}: HoverHighlightCellProps) => {
  const navigate = useNavigate()
  const { hovered, ref } = useHover()
  const isModifierPressed = useCmdClick()
  const shouldHighlight = hovered && isModifierPressed && !disabled

  const handleClick = () => {
    if (!disabled) {
      navigateWithCmd(id, isModifierPressed, navigate, basePath)
    }
  }

  return (
    <Text
      ref={ref}
      style={{
        ...highlightCell(shouldHighlight),
        cursor: disabled ? "not-allowed" : "pointer",
        color: disabled
          ? "var(--mantine-color-textMuted-0)"
          : shouldHighlight
            ? "var(--mantine-color-primaryHighlight-0)"
            : undefined,
      }}
      fz="sm"
      onClick={handleClick}
    >
      {value}
    </Text>
  )
}
